const getDataLayer = () => window?._hsq

const pushToDataLayer = (obj = {}) => {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.log("%c[Hubspot]", "font-weight: bold", obj)
  } else {
    const _hsq = getDataLayer()

    if (_hsq) {
      _hsq.push(obj)
    }
  }
}

export const trackHubspotPageLoad = (layer) => {
  pushToDataLayer(layer)
}
